import API_BASE_URL from '../config';

export async function getBrandLogos() {
  const res = await fetch(`${API_BASE_URL}/brand-logos`);
  if (!res.ok) throw new Error('Failed to fetch brand logos');
  return res.json();
}

export async function setBrandLogoUrl(brand, url, token) {
  const res = await fetch(`${API_BASE_URL}/brand-logos/admin/${encodeURIComponent(brand)}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : ''
    },
    body: JSON.stringify({ url })
  });
  return res.json();
}

export async function uploadBrandLogo(brand, file, token) {
  const fd = new FormData();
  fd.append('image', file);
  const res = await fetch(`${API_BASE_URL}/brand-logos/admin/${encodeURIComponent(brand)}`, {
    method: 'PUT',
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    },
    body: fd
  });
  return res.json();
}

export async function deleteBrandLogo(brand, token) {
  const res = await fetch(`${API_BASE_URL}/brand-logos/admin/${encodeURIComponent(brand)}`, {
    method: 'DELETE',
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  });
  return res.json();
}

const brandLogoService = { getBrandLogos, setBrandLogoUrl, uploadBrandLogo, deleteBrandLogo };
export default brandLogoService;
